import { format, utcToZonedTime } from 'date-fns-tz';
import { parseISO } from 'date-fns';

export function collapseSection(element) {
  let sectionHeight = element.scrollHeight;

  let elementTransition = element.style.transition;
  element.style.transition = '';

  requestAnimationFrame(function() {
    element.style.height = sectionHeight + 'px';
    element.style.transition = elementTransition;

    requestAnimationFrame(function() {
      element.style.height = 0 + 'px';
    });
  });

  element.classList.remove('is-active');
}

export function expandSection(element) {
  let sectionHeight = element.scrollHeight;

  element.style.height = sectionHeight + 'px';

  element.style.height = 'auto';

  element.classList.add('is-active');
}

export function formatDate(date) {
  if (!date) {
    return '';
  }

  return format(utcToZonedTime(date, { timeZone: 'UTC' }), 'EEE do LLL yyyy');
}

export function formatDateRange(start_date, end_date) {
  const startDate = new Date(start_date);
  const endDate = new Date(end_date);

  const startFormatter = new Intl.DateTimeFormat('en-GB', {
      weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'
  });

  const endFormatter = new Intl.DateTimeFormat('en-GB', {
      weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC'
  });

  return startFormatter.format(startDate) + ' - ' + endFormatter.format(endDate);
}


export function formatPrice(price) {
  return (price / 100)
    .toFixed(0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
